import { render, staticRenderFns } from "./AdvancedHistory.vue?vue&type=template&id=c2553bf6&scoped=true&"
import script from "./AdvancedHistory.vue?vue&type=script&lang=js&"
export * from "./AdvancedHistory.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedHistory.vue?vue&type=style&index=0&id=c2553bf6&prod&lang=css&"
import style1 from "./AdvancedHistory.vue?vue&type=style&index=1&id=c2553bf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2553bf6",
  null
  
)

export default component.exports